import { render, staticRenderFns } from "./DataDeletionRequests.vue?vue&type=template&id=3b7ba454&scoped=true"
import script from "./DataDeletionRequests.vue?vue&type=script&lang=js"
export * from "./DataDeletionRequests.vue?vue&type=script&lang=js"
import style0 from "./DataDeletionRequests.vue?vue&type=style&index=0&id=3b7ba454&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b7ba454",
  null
  
)

export default component.exports